import { createClient } from '@supabase/supabase-js';

// Project URL and anon key from environment
const SUPABASE_URL = 'https://fhzcpgnswghxvkvhcqnx.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZoemNwZ25zd2doeHZrdmhjcW54Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MDM2MDYsImV4cCI6MjA2OTI3OTYwNn0.o9YvUlck0taErCcvwhBb47VX6n6N3EPkbhb4RrsXw1g';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;